import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import warehousesService from "../../services/warehouses.service";
import { WarehouseResponse } from "types/responses.type";

interface WarehousesState {
  items: WarehouseResponse[];
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
}

const initialState: WarehousesState = {
  items: [],
  loading: false,
  error: null,
  page: 1,
  hasMore: true,
};

export const fetchWarehouses = createAsyncThunk(
  "warehouses/fetchWarehouses",
  async (_, { rejectWithValue }) => {
    try {
      const response = await warehousesService.getWarehouses();
      if (!response.ok || !response.data) {
        return rejectWithValue(
          response.errorMessage || "Failed to fetch warehouses"
        );
      }
      return { data: response.data };
    } catch (error) {
      return rejectWithValue("An unexpected error occurred");
    }
  }
);

const warehousesSlice = createSlice({
  name: "warehouses",
  initialState,
  reducers: {
    resetWarehousesState: (state) => {
      state.items = [];
      state.page = 1;
      state.hasMore = true;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWarehouses.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchWarehouses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetWarehousesState } = warehousesSlice.actions;
export default warehousesSlice.reducer;
